import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CompanyPageModifyPlanModalComponent } from './company-page-modify-plan-modal.component';

@NgModule({
  declarations: [CompanyPageModifyPlanModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot()
  ],
  exports: [CompanyPageModifyPlanModalComponent],
  entryComponents: [CompanyPageModifyPlanModalComponent]
})
export class CompanyPageModifyPlanModalModule { }
